import "./SolarInstallers.module.css";
import Header from "@/reusable_sections/Header";
import SolarHero from "./sections/SolarHero";
import Partnerships from "./sections/Partnerships";
import Footer from "@/reusable_sections/Footer";
export default function SolarInstallersPage() {
  return <div>
      <Header />
      <SolarHero />
      <Partnerships />
      <Footer />
    </div>;
}